.wrapper {
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 16px;
  background: #fff;
  font-family: Oxygen, sans-serif;
}
